import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-mv-10" }
const _hoisted_2 = { class: "h-flex-center" }
const _hoisted_3 = { class: "h-font-14 h-fw-500 h-pl-15" }
const _hoisted_4 = { class: "h-pos-rel h-flex-center" }
const _hoisted_5 = { class: "h-pos-abs h-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ "icon-checked__active": _ctx.isActive }, "icon-checked b-form-menu-item"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FwIcon, {
          class: "h-mt-2",
          icon: _ctx.leftIcon,
          size: "20",
          color: "#BEC7D4"
        }, null, 8, ["icon"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-checked__background" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FwIcon, {
            icon: "ok",
            size: "12",
            color: "#ffffff"
          })
        ])
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}